import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions/execute-time.actions';
import { Col, Row, Form, Modal, Select, Input } from 'antd';
import { dspxGetChildrens, dspxGetWorkerChildrens } from '../helpers/dspx-utils'
import { ReactComponent as SetExecuterIcon } from '../resource/forms/ManWrench.svg';
import { MODAL_UNSAVED_DATA_WARNING_TITLE, UNSAVED_DATA_WARNING_TEXT } from '../constants/text.constants';

const ExecuterForm = Form.create()(
	class extends React.Component {

		render() {
			const { visible, onCancel, onCreate, form, fprops, confirmLoading } = this.props;
			const { getFieldDecorator } = form;

			return (
				<Modal className='dspx-icon-header'
					width={400}
					visible={visible}
					title={<div><SetExecuterIcon style={{ height: 60, verticalAlign:'middle', marginRight: 10 }}/> Назначить исполнителя</div>}
					confirmLoading={confirmLoading}
					onCancel={onCancel}
					onOk={onCreate} >
					<Form layout="vertical">
					{getFieldDecorator('request', { initialValue: fprops.request })(
							<Input type='hidden' />)}

						<Row gutter={16}>
							<Col span={24}>
								<Form.Item label="Исполнитель" >
									{getFieldDecorator('executerId', {
											  initialValue: (fprops.executer && fprops.listExecuter.some(e=>e.id == fprops.executer)) ? fprops.executer : undefined,
												rules: [{ required: true, message: 'Пожалуйста, выберите исполнителя' }]
											})(
										<Select
											showSearch
											placeholder="исполнитель"
											notFoundContent='нет данных'
											optionLabelProp="label"
											optionFilterProp="searchtext" >
											{dspxGetWorkerChildrens(fprops.listExecuter)}
										</Select>)}
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>
			);
		}
	});

class ExecuterContainer extends Component {
	state = {
		confirmLoading: false,
	};

	handleCancel = () => {
		return new Promise((resolve) => {
			const form = this.formRef && this.formRef.props && this.formRef.props.form;
			const hasTouchedFields = form && typeof form.isFieldsTouched === 'function' ? form.isFieldsTouched() : false;

			if (hasTouchedFields) {
				Modal.confirm({
					title: MODAL_UNSAVED_DATA_WARNING_TITLE,
					content: UNSAVED_DATA_WARNING_TEXT,
					okType: 'danger',
					okText: 'Да',
					cancelText: 'Отмена',
					onOk: () => {
						this.resetAndClose();
						resolve(true);
					},
					onCancel: () => resolve(false),
				});
				return;
			}

			this.resetAndClose();
			resolve(true);
		});
	}

	resetAndClose = () => {
		const form = this.formRef && this.formRef.props && this.formRef.props.form;
		if (form) form.resetFields();
		this.props.dispatch(actions.closeExecuterModal());
	}

	handleCreate = () => {
		const form = this.formRef.props.form;		

		form.validateFields(async (err, values) => {

			if (err) return;

			if (typeof this.props.updateExecuter === 'function') {
				this.setState({
					confirmLoading: true,
				});

				await this.props.updateExecuter(values);

				this.setState({
					confirmLoading: false,
				});
			} else {
				this.props.dispatch(actions.postExecuter(values));
			}

			form.resetFields();
			this.props.dispatch(actions.closeExecuterModal());
		});
	}

	saveFormRef = (formRef) => {

		this.formRef = formRef;
	}

	render() {

		return (
			<ExecuterForm
				wrappedComponentRef={this.saveFormRef}
				visible={this.props.executerModalVisible}
				dispatch={this.props.dispatch}
				onCancel={this.handleCancel}
				onCreate={this.handleCreate}
				fprops={this.props}
				confirmLoading={this.state.confirmLoading}
			/>
		)
	}
}

function mapStateToProps(state) {
	const { executeTimeStore } = state;
	const { listExecuter } = state.newRequestStore;

	return { ...executeTimeStore, listExecuter };
}

export default connect(mapStateToProps)(ExecuterContainer);
